namespace $.$$ {

	$mol_style_define( $shm_hitalama_resilience_page, {

		Content: {
			flex: {
				direction: 'column',
			},
			align: {
				items: 'flex-start',
			},
		},

		Details: {
			color: $mol_theme.shade,
		},

	} )

}
